import { render, staticRenderFns } from "./StoreCard.vue?vue&type=template&id=2769edba&scoped=true"
import script from "./StoreCard.vue?vue&type=script&lang=js"
export * from "./StoreCard.vue?vue&type=script&lang=js"
import style0 from "./StoreCard.vue?vue&type=style&index=0&id=2769edba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2769edba",
  null
  
)

export default component.exports